// extracted by mini-css-extract-plugin
export default {"table":"Q5yN8CcrHC7F68ZbU_fy","cell":"O69Zu8qHPOjX51GmJVse","header":"gGLXk8gEpe9Y0LEnavxQ"};